'use client'

import { Button, Link, Typography } from '@gyym/ui'
import React from 'react'

import { ButtonContainer, Container, InnerContainer } from './styles'

export interface ErrorViewProps {
  statusCode: number
  message: React.ReactNode
}

export const ErrorView = ({ statusCode, message }: ErrorViewProps) => {
  return (
    <Container title={`${statusCode} Error`}>
      <InnerContainer>
        <svg
          width="104px"
          height="104px"
          viewBox="0 0 104 104"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path
              d="M52.0000005,71.5 C55.1633338,71.5 58.0233337,72.3233332 60.5366669,73.7966665 C61.0566669,73.1899999 64.2633334,69.5499999 64.9133334,68.8566666 C61.2300002,66.43 56.8100004,65 52.0000005,65 C47.1900007,65 42.7700009,66.43 39.0433343,68.8133333 C43.2466675,73.5366665 39.0866677,68.8999999 43.4200008,73.7533332 C45.9766674,72.3233332 48.8366673,71.5 52.0000005,71.5 M52,86.6666667 C32.8466667,86.6666667 17.3333333,71.1533333 17.3333333,52 C17.3333333,32.8466667 32.8466667,17.3333333 52,17.3333333 C71.1533333,17.3333333 86.6666667,32.8466667 86.6666667,52 C86.6666667,71.1533333 71.1533333,86.6666667 52,86.6666667 M51.9566667,8.66666667 C75.92,8.66666667 95.3333333,28.08 95.3333333,52 C95.3333333,75.92 75.92,95.3333333 51.9566667,95.3333333 C28.0366667,95.3333333 8.66666667,75.92 8.66666667,52 C8.66666667,28.08 28.0366667,8.66666667 51.9566667,8.66666667 Z M35.75,39 C32.7563889,39 30.3333333,41.4230556 30.3333333,44.4166667 C30.3333333,47.4102778 32.7563889,49.8333333 35.75,49.8333333 C38.7436111,49.8333333 41.1666667,47.4102778 41.1666667,44.4166667 C41.1666667,41.4230556 38.7436111,39 35.75,39 Z M66.0833333,39 C63.0933333,39 60.6666667,41.4230556 60.6666667,44.4166667 C60.6666667,47.4102778 63.0933333,49.8333333 66.0833333,49.8333333 C69.0733333,49.8333333 71.5,47.4102778 71.5,44.4166667 C71.5,41.4230556 69.0733333,39 66.0833333,39 Z"
              fill="#777777"
            ></path>
            <path
              d="M67.1666667,78 C71.9531345,78 75.8333333,74.1198012 75.8333333,69.3333333 C75.8333333,66.1423548 72.9444444,60.364577 67.1666667,52 C61.3888889,60.364577 58.5,66.1423548 58.5,69.3333333 C58.5,74.1198012 62.3801988,78 67.1666667,78 Z"
              fill="#A3D1F1"
            ></path>
          </g>
        </svg>
      </InnerContainer>

      <Typography as="h1" variant="subhead1" textAlign="center" color="gray.02">
        {statusCode} Error
      </Typography>

      <Typography as="p" textAlign="center" color="gray.02" mt={10}>
        {message}
      </Typography>

      <ButtonContainer>
        <Button size="lg" asChild>
          <Link href="/">TOPページを開く</Link>
        </Button>
      </ButtonContainer>
    </Container>
  )
}
